'use client';
import { TrackComponent } from '@eliadmin/core/src/components/analytics/analytics-helpers';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useEffect, useState } from 'react';

function createTransactionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

function getPersistentTransactionId(id: number) {
  const key = 'persistentTransactionId';
  let transactionId = localStorage?.getItem(key);
  if (!transactionId) {
    transactionId = id + '_' + createTransactionId();
    localStorage.setItem(key, transactionId);
  }
  return transactionId;
}

export const TrackConversionClient = (props: {
  conversionMeasurementKey: string;
  tour_id: number;
}) => {
  const [transactionId, setTransactionId] = useState('');
  const currency = useGlobalStore(state => state.generalLayout.currency);

  useEffect(() => {
    setTransactionId(getPersistentTransactionId(props.tour_id));
  }, [props.tour_id]);

  return (
    <>
      {transactionId && (
        <TrackComponent
          eventName={'conversion'}
          eventParams={{
            currency,
            transaction_id: transactionId,
            value: 1.0,
            send_to: props.conversionMeasurementKey,
          }}
        />
      )}
    </>
  );
};
